module.exports = __webpack_public_path__ + "ipetbooking-landing/img/hand-icon.9846a051.svg";